import { render, staticRenderFns } from "./x-user-avatar.vue?vue&type=template&id=3215fade&scoped=true&"
import script from "./x-user-avatar.vue?vue&type=script&lang=js&"
export * from "./x-user-avatar.vue?vue&type=script&lang=js&"
import style0 from "./x-user-avatar.vue?vue&type=style&index=0&id=3215fade&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3215fade",
  null
  
)

export default component.exports